<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--    CARD START-->
        <div>
            <div class="flex items-center justify-center h-full p-20 border-2 border-white border-dashed rounded-md py-96">
                <div>
                    <div class="flex items-center justify-center">
                        <div class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                            <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                                <IconPersonSVG class="w-24 h-24" />
                            </div>
                        </div>
                    </div>

                    <button
                        @click="initModal"
                        class="mt-16 block font-normal text-center underline title-lg text-primary hover:text-blue-300 transition.all duration-200 ease-in-out"
                    >
                        {{ $t('info.add_auth_person') }}
                    </button>
                </div>
            </div>
        </div>
        <!--    CARD END-->

        <!--    MODAL START-->
        <div class="micromodal" id="add_auth_person" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.add_auth_person') }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close>
                            <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                                <IconXSVG />
                            </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <div class="flex self-form-wrap">
                            <div :class="['w-full self-form-wrap-item', { 'e5-error': firstNameEmpty }]">
                                <label class="e5-form-label" for="eesnimi"
                                    >{{ $t('signup.fname') }} <span class="e5-form-field-required">({{ $t('info.required') }})</span
                                    ><span class="e5-form-field-required">*</span></label
                                >
                                <div class="relative">
                                    <input
                                        @blur="checkFirstName"
                                        type="text"
                                        id="eesnimi"
                                        placeholder=""
                                        name="eesnimi"
                                        v-model="request.first_name"
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <div :class="['w-full self-form-wrap-item', { 'e5-error': lastNameEmpty }]">
                                <label class="e5-form-label" for="perenimi"
                                    >{{ $t('signup.lname') }} <span class="e5-form-field-required">({{ $t('info.required') }})</span
                                    ><span class="e5-form-field-required">*</span></label
                                >
                                <div class="relative">
                                    <input
                                        @blur="checkLastName"
                                        type="text"
                                        id="perenimi"
                                        placeholder=""
                                        name="perenimi"
                                        v-model="request.last_name"
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <div :class="['w-full self-form-wrap-item', { 'e5-error': invalidPersonalCode && personalCodeEntered }]">
                                <label class="e5-form-label" for="isikukood"
                                    >{{ $t('info.identity_code') }}
                                    <span v-if="request.country_of_residence === 'EE'" class="e5-form-field-required"
                                        >({{ $t('info.required') }})</span
                                    ><span v-if="request.country_of_residence === 'EE'" class="e5-form-field-required">*</span></label
                                >
                                <div class="relative">
                                    <input
                                        @blur="checkPersonalCode()"
                                        type="text"
                                        id="isikukood"
                                        placeholder=""
                                        name="isikukood"
                                        v-model="request.personal_code"
                                        class="e5-input"
                                    />
                                </div>
                            </div>
                            <Dob
                                :label="$t('info.dob')"
                                is-dob
                                @update:date="updateBirthDate"
                                :presetDate="this.birthDateFromIdCode"
                                :disable="!invalidPersonalCode && personalCodeEntered && this.request.personal_code !== ''"
                            />

                            <div :class="['w-full self-form-wrap-item', { 'e5-error-choices': invalidCountry }]">
                                <label class="e5-form-label" for="country_of_residence"
                                    >{{ $t('info.country_of_residence')
                                    }}<span class="e5-form-field-required">({{ $t('info.required') }})</span
                                    ><span class="e5-form-field-required">*</span></label
                                >
                                <div class="relative">
                                    <div class="self-form-select-wrap">
                                        <select
                                            name="country_of_residence"
                                            id="country_of_residence"
                                            multiple
                                            class="self-multiselect-add-auth-cor"
                                        ></select>
                                    </div>
                                </div>
                            </div>

                            <div :class="['w-full self-form-wrap-item', { 'e5-error-choices': invalidLanguage }]">
                                <label class="e5-form-label" for="language"
                                    >{{ $t('info.language') }}<span class="e5-form-field-required">({{ $t('info.required') }})</span
                                    ><span class="e5-form-field-required">*</span></label
                                >
                                <div class="relative">
                                    <div class="self-form-select-wrap">
                                        <select name="language" id="language" multiple class="self-multiselect-add-auth-language"></select>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="email">{{ $t('footer.email') }}</label>
                                <div class="relative">
                                    <input
                                        type="text"
                                        id="email"
                                        placeholder=""
                                        name="email"
                                        v-model="request.business_email"
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="telefon">{{ $t('info.business_phone') }}</label>
                                <div class="relative">
                                    <input
                                        type="text"
                                        id="telefon"
                                        placeholder=""
                                        name="telefon"
                                        v-model="request.business_phone"
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="mobile">{{ $t('info.business_mobile_phone') }}</label>
                                <div class="relative">
                                    <input
                                        type="text"
                                        id="mobile"
                                        placeholder=""
                                        name="mobile"
                                        v-model="request.business_mobile_phone"
                                        class="e5-input"
                                    />
                                </div>
                            </div>
                            <div class="w-full">
                                <Dob
                                    :label="$t('reports.table.service_start_date')"
                                    @update:date="updateStartDate"
                                    :class="[{ 'e5-error-dob': invalidStartEndDate }]"
                                />
                            </div>
                            <div class="w-full">
                                <Dob
                                    :label="$t('reports.table.service_end_date')"
                                    :disable="isIndefinite.length === 1"
                                    @update:date="updateEndDate"
                                    :class="[{ 'e5-error-dob': invalidStartEndDate }]"
                                />
                            </div>
                            <div class="w-full self-form-wrap-item">
                                <input
                                    @change="invalidStartEndDate = !isStartDateBeforeEndDate"
                                    class="e5-checkbox"
                                    type="checkbox"
                                    id="addAuthPersonIndefinite"
                                    name="addAuthPersonIndefinite"
                                    value="2999-12-31"
                                    v-model="isIndefinite"
                                />
                                <label class="" for="addAuthPersonIndefinite">
                                    {{ $t('info.indefinite_end_date') }}
                                </label>
                            </div>

                            <div class="flex items-center justify-between px-8 pt-16 w-full">
                                <div>
                                    <button @click="addNewAuthPerson" :disabled="!isFormOk" class="self-btn-primary">
                                        {{ $t('info.save') }}
                                        <span class="text-yellow-300 self-btn-primary__icon">
                                            <IconArrowAltSVG />
                                        </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close class="self-btn-plain">
                                        <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                                            <IconXSVG />
                                        </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--    MODAL END-->
        <!-- NOTIFICATION MODAL START -->
        <div class="micromodal" id="notificationModalAddAuthPerson" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ notificationModalText }}</h2>
                    </header>
                    <div class="micromodal__content">
                        <div class="flex self-form-wrap">
                            <div class="flex items-center justify-between w-full px-8 pt-16">
                                <div>
                                    <button data-micromodal-close class="self-btn-primary">OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- NOTIFICATION MODAL END -->
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import IconPersonSVG from '@/assets/static/icons-src/icon-person.svg';
import IconXSVG from '@/assets/static/icons-src/icon-x.svg';
import IconArrowAltSVG from '@/assets/static/icons-src/icon-arrow-alt.svg';
import Dob from '@/components/info-view-components/Dob.vue';
import { IAuthorizedPersonRequest } from '@/domain/ITravelManagerOrAuthorizedPerson';
import Choices from 'choices.js';
import $ from 'jquery';
import MicroModal from 'micromodal';
import store from '@/store';
import { ICountry } from '@/domain/ICountry';

@Component({
    components: {
        Dob,
        IconPersonSVG,
        IconXSVG,
        IconArrowAltSVG
    }
})
export default class AddAuthorizedPerson extends Vue {
    isIndefinite = [];

    firstNameEmpty = false;
    lastNameEmpty = false;
    invalidPersonalCode = true;
    personalCodeEntered = false;
    invalidStartEndDate = false;
    invalidCountry = false;
    invalidLanguage = false;

    birthDateFromIdCode = '';

    notificationModalText = '';

    choicesMap = { cor: { id: 'cor', choices: null }, language: { id: 'language', choices: null } };

    request: IAuthorizedPersonRequest = {
        customer_id: store.getters.getCustomerId,
        first_name: '',
        last_name: '',
        start_date: new Date().toISOString().split('T')[0],
        end_date: new Date().toISOString().split('T')[0],
        personal_code: '',
        birth_date: new Date().toISOString().split('T')[0],
        business_email: '',
        business_phone: '',
        business_mobile_phone: '',
        authperson_id: null,
        country_of_residence: null,
        language: null
    };

    get countries(): ICountry[] {
        return store.state.country;
    }

    get isFormOk() {
        return (
            this.isStartDateBeforeEndDate &&
            this.request.first_name !== '' &&
            this.request.last_name !== '' &&
            (this.request.country_of_residence === 'EE' ? !this.invalidPersonalCode : true) &&
            this.request.country_of_residence &&
            this.request.language
        );
    }

    get isStartDateBeforeEndDate() {
        if (this.isIndefinite.length !== 0) return true;
        return new Date(this.request.start_date) <= new Date(this.request.end_date);
    }

    checkFirstName() {
        this.firstNameEmpty = this.request.first_name === '';
    }

    checkLastName() {
        this.lastNameEmpty = this.request.last_name === '';
    }

    checkPersonalCode() {
        this.personalCodeEntered = true;
        this.invalidPersonalCode = !/^\d{11}$/.test(this.request.personal_code.trim());
        // eslint-disable-next-line no-useless-return
        if (this.invalidPersonalCode) return;
        else this.calculateBirth(); // Update birthdate
    }

    private calculateBirth() {
        const year = this.request.personal_code.substring(1, 3);
        const month = parseInt(this.request.personal_code.substring(3, 5));
        const day = parseInt(this.request.personal_code.substring(5, 7));

        // Determine the century based on the first digit of the personal code
        let century: string;
        switch (this.request.personal_code.charAt(0)) {
        case '1':
        case '2':
            century = '18';
            break;
        case '3':
        case '4':
            century = '19';
            break;
        case '5':
        case '6':
            century = '20';
            break;
        case '7':
        case '8':
            century = '21';
            break;
        default:
            century = 'Invalid';
            return;
        }

        // Construct the birthdate
        const birthDate = new Date(parseInt(century + year), month - 1, day);
        this.birthDateFromIdCode = birthDate.toLocaleDateString('et-EE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }

    private initMultiSelects() {
        const languages = {
            et: 1,
            en: 2,
            ru: 3
        };
        const placeholderText = this.$t('reports.form.choose') as string;
        Object.entries(this.choicesMap).forEach(([key, value]) => {
            if (value.choices) {
                value.choices.destroy();
            }
            const selectElement = document.querySelector(`.self-multiselect-add-auth-${value.id}`) as HTMLSelectElement;
            if (selectElement === null) return;

            value.choices = new Choices(document.querySelector(`.self-multiselect-add-auth-${value.id}`), {
                removeItemButton: true,
                itemSelectText: placeholderText,
                maxItemCount: 2,
                maxItemText: this.$t('reports.form.only_one_can_be_selected') as string,
                noChoicesText: this.$t('reports.form.no_choices_to_choose_from') as string,
                allowHTML: true
            });

            value.choices.passedElement.element.addEventListener(
                'change',
                (event) => {
                    const selectedValues = $(event.target).val() as string[];
                    if (selectedValues.length > 1) {
                        // Convert the HTMLSelectElement to an array-like object
                        const options = Array.from(selectElement.options);
                        // Find the option with the specified value and remove it
                        const optionToRemove = options.find((option) => option.value === selectedValues[0]);
                        if (optionToRemove) {
                            selectElement.removeChild(optionToRemove);
                        }
                        // Update Choices.js instance to reflect the changes
                        value.choices.removeActiveItemsByValue(value.id === 'language' ? parseInt(selectedValues[0]) : selectedValues[0]);
                        selectedValues.splice(0, 1);
                        value.choices.setChoiceByValue(selectedValues);
                    }
                    if (value.id === 'language') {
                        this.invalidLanguage = selectedValues.length === 0;
                        this.request.language = parseInt(selectedValues[0]);
                    } else {
                        this.invalidCountry = selectedValues.length === 0;
                        this.request.country_of_residence = selectedValues[0];
                    }
                },
                false
            );
            if (value.id === 'language') {
                value.choices.setChoices(
                    Object.entries(languages).map(([lang, num]) => ({
                        value: num,
                        label: this.$t(`info.langs.${lang}`),
                        selected: num === this.request?.language
                    })),
                    'value',
                    'label',
                    false
                );
            } else {
                value.choices.setChoices(
                    this.countries.map((country) => ({
                        value: country.country_code,
                        label: country.country_name,
                        selected: country.country_code === this.request?.country_of_residence
                    })),
                    'value',
                    'label',
                    false
                );
            }
        });
    }

    updateBirthDate(newBirthDate: string) {
        this.request.birth_date = newBirthDate;
    }

    updateStartDate(newStartDate: string) {
        this.request.start_date = newStartDate;
        this.invalidStartEndDate = !this.isStartDateBeforeEndDate;
    }

    updateEndDate(newEndDate: string) {
        this.request.end_date = newEndDate;
        this.invalidStartEndDate = !this.isStartDateBeforeEndDate;
    }

    async addNewAuthPerson() {
        this.request.end_date = this.isIndefinite.length === 0 ? this.request.end_date : this.isIndefinite[0];
        const res = await store.dispatch('addAuthorizedPerson', this.request);
        MicroModal.close('add_auth_person');

        if (res?.status === 403) {
            this.notificationModalText = this.$t(`info.${res.data.errorCodes[0]}`) as string;
            MicroModal.show('notificationModalAddAuthPerson');
            return;
        }
        if (res?.status === 201) {
            await store.dispatch('updateCustomerInfo');
            console.debug('here');
            return;
        }
        this.requestErrorFunction();
    }

    private requestErrorFunction() {
        Vue.notify({
            group: 'api',
            title: 'Server error',
            text: 'Error while while processing a add new authorized person request',
            type: 'warn'
        });
    }

    initModal() {
        MicroModal.show('add_auth_person');
        this.request = {
            customer_id: store.getters.getCustomerId,
            first_name: '',
            last_name: '',
            start_date: new Date().toISOString().split('T')[0],
            end_date: new Date().toISOString().split('T')[0],
            personal_code: '',
            birth_date: new Date().toISOString().split('T')[0],
            business_email: '',
            business_phone: '',
            business_mobile_phone: '',
            authperson_id: null,
            country_of_residence: 'EE',
            language: 1
        };
        this.initMultiSelects();
        this.firstNameEmpty = false;
        this.lastNameEmpty = false;
        this.invalidPersonalCode = true;
        this.personalCodeEntered = false;
        this.invalidStartEndDate = false;
        this.invalidCountry = false;
        this.invalidLanguage = false;
        this.isIndefinite = [];
    }
}
</script>

<style scoped></style>
